import React, { Fragment, memo, useEffect } from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

import { RoutesList } from "./routesList";
import NotFound from "../pages/notFound";
import MainLayout from "../pages/layout/main-layout";
import Login from "../pages/auth/login";
import { showModules } from "../store/actions";
import { useDispatch } from "react-redux";

const RouterComp = memo(() => {
  // const [updatedSidebarArray, setUpdatedSidebarArray] = useState([]);
  // const [permissionArray, setPermissionArray] = useState([]);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(
  //     showModules({
  //       callback: (showData) => {
  //         setPermissionArray(showData);
  //       },
  //     })
  //   );
  // }, [dispatch]);

  

 
  // useEffect(() => {
  //   if (permissionArray.length > 0) {
  //     const updatedArray = RoutesList.map((item) => {
  //       const permissionItem = permissionArray.find(
  //         (perm) => perm.name === item.label
  //       );
  //       return permissionItem ? { ...item, id: permissionItem._id } : item;
  //     });
  //     setUpdatedSidebarArray(updatedArray);
  //   }
  // }, [permissionArray]);
  
  return (
    <div>
      <Fragment>
        <React.Suspense
          fallback={
            <Box
              className="d-flex"
              style={{
                height: "100vh",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress color="secondary" />
            </Box>
          }
        >
          <Router>
            <Switch>
              <Route exact path="/" component={Login} />
              {RoutesList?.map((itm, index) => (
                <Route
                  key={index}
                  path={itm?.path}
                  exact
                  children={() => (
                    <MainLayout
                      component={itm?.layout}
                      isAuthProtected={itm?.isAuthProtected}
                    />
                  )}
                />
              ))}
              <Route path="*" component={NotFound} />
            </Switch>
          </Router>
        </React.Suspense>
      </Fragment>
    </div>
  );
});

export default RouterComp;
